import { defineCustomElements } from "@komodo-design-system/komodo-core-web-components/loader";
import trackPerformance from "./utils/trackPerformance";

trackPerformance("Komodo-Core: pre-initialization");

defineCustomElements();

trackPerformance("Komodo-Core: post-initialization");
